// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"3777e1ca","559":"60ec5c0b","569":"a0caedc3","642":"71d795a1","687":"94ed4c44","756":"be128b67","767":"702a0a0e","852":"acd46535","881":"96d7125b","889":"985ca837"}[chunkId] + ".chunk.js";
};